// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___3tRjf","m-signature-pad--body":"styles__m-signature-pad--body___31zx4","m-signature-pad--footer":"styles__m-signature-pad--footer___3_u-5","description":"styles__description___W7XN_","button":"styles__button___20jTP","clear":"styles__clear___1T4DT","save":"styles__save___XXSRu","m-signature-pad":"styles__m-signature-pad___u4BfT","github":"styles__github___3kEzR","selectWrapper":"styles__selectWrapper___4yoQO","levelerSelectWrapper":"styles__levelerSelectWrapper___2hICe"};


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/components/ReactSelect/styles.scss
// module id = IMTd
// module chunks = client